export default __webpack_public_path__ + "static/media/CITYSEARCH.75835462.png";